const pizzaData = [
  {
    name: "5 Cogumelos",
    ingredients:
      "Molho de Tomate | Mozzarella 100% | Cogumelos Paris, Shiitake, Shimaji, Portobello, Marron | Parmesão",
    price: 15,
    soldOut: false,
  },
  {
    name: "Do Bosque",
    ingredients:
      "Molho de Tomate | Mozzarella 100% | Requeijão | Espargos | Ovo | Salsa | Azeite de Trufa | Cebola Confitada | Amêndoa Torrada",
    price: 15,
    soldOut: false,
  },
  {
    name: "Terra e Mar",
    ingredients:
      "Molho de Tomate | Mozzarella 100% | Camarão | Pimento Assado | Molho Pesto | Cebola Confitada",
    price: 15,
    soldOut: false,
  },
  {
    name: "Marron",
    ingredients:
      "Mozzarella 100% | Cogumelos Marron | Alho | Salsa | Parmesão | Azeite de Trufa ",
    price: 15,
    soldOut: false,
  },
  {
    name: "Tomatina",
    ingredients:
      "Molho de Tomate | Mozzarella 100% | Manjericão | Tomate Cherry | Mozzarella Di Bufala | Parmesão",
    price: 15,
    soldOut: false,
  },
  {
    name: "Figo",
    ingredients:
      "Mozzarella 100% | Figo | Gorgonzola | Presunto |  Mel | Oregãos",
    price: 15,
    soldOut: false,
  },
  {
    name: "Trufa",
    ingredients: "Gorgonzola | Salsa Trufada | Rúcula | Azeite de Trufa",
    price: 15,
    soldOut: false,
  },
];

const rolinhoData = [
  {
    name: "Alho",
    ingredients: "Manteiga de Alho | Mozzarella 100%",
    price: 5,
    soldOut: false,
  },
  {
    name: "Diávola",
    ingredients: "Mozzarella 100% | Pepperoni | Oregãos",
    price: 6.5,
    soldOut: false,
  },
  {
    name: "Camarão",
    ingredients: "Mozzarella 100% | Camarão | Catupiri | Oregãos",
    price: 7.5,
    soldOut: false,
  },
  {
    name: "Anchovas",
    ingredients: "Mozzarella 100% | Anchovas | Alcaparras",
    price: 7.5,
    soldOut: false,
  },
  {
    name: "Trufa",
    ingredients: "Queijo Gorgonzola | Salsa Trufada | Azeite de Trufa",
    price: 8,
    soldOut: false,
  },
];

const saladData = [
  {
    name: "Pêra e Parmesão",
    ingredients: "Rúcula | Parmesão | Pêra | Azeite | Creme Balsâmico",
    price: 11.5,
    soldOut: false,
  },
  {
    name: "Caprese",
    ingredients: "Tomate | Mozzarella Di Bufala",
    price: 9.5,
    soldOut: false,
  },
  // {
  //   name: "Rúcula",
  //   ingredients: "Rúcula | Tomate Cherry | Azeite",
  //   price: 5,
  //   soldOut: false,
  // },
];

const promotionsData = [
  {
    // name: "Não temos promoções de momento.",
    ingredients: "Não temos promoções de momento.",
    // price: 6,
    // soldOut: false,
  },
];

const newsData = [
  {
    name: "Fettuccine de Cogumelos",
    ingredients: "Marron | Creme Fresco | Parmesão",
    price: 14.5,
    soldOut: false,
  },
  {
    name: "Tiramisù",
    ingredients: "Café | Palitos La Reine | Cacau em Pó | Ovos",
    price: 4.5,
    soldOut: false,
  },
];

export { pizzaData, rolinhoData, saladData, promotionsData, newsData };
